module.exports = __webpack_public_path__ + "static/media/PWRCell.4f73a029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PWRCell.jpg
// module id = 1026
// module chunks = 0